export default class CouponManager {
    constructor(mainController, modalSelector, uiManager) {
        this.mainController = mainController;
        this.modalSelector = modalSelector;
        this.uiManager = uiManager;
        this.appliedCoupons = [];
    }

    initializeCouponHandling() {
        if (jQuery('.applied-coupons-container').length === 0) {
            jQuery('.coupon-form').after('<div class="applied-coupons-container"></div>');
        }

        jQuery('#vindi-apply-coupon').on('click', () => {
            this.applyCoupon();
        });

        jQuery('#vindi-coupon-code').on('keypress', (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this.applyCoupon();
            }
        });
    }

    applyCoupon() {
        const couponCode = jQuery('#vindi-coupon-code').val().trim();
        if (!couponCode) {
            this.uiManager.showCouponMessage('Por favor, informe um código de cupom.', 'error');
            return;
        }

        const applyButton = jQuery('#vindi-apply-coupon');
        const loader = jQuery('.coupon-loader');

        applyButton.prop('disabled', true);
        loader.show();
        this.uiManager.showCouponMessage('', '');
        this.uiManager.showTotalLoader();

        const productInfo = this.mainController.getProductInfo();
        const paymentMethod = jQuery('input[name="payment_method"]:checked').val() || '';

        jQuery.ajax({
            url: vindiOneClick.ajax_url,
            type: 'POST',
            data: {
                action: 'validate_one_click_coupon',
                nonce: vindiOneClick.nonce,
                product_id: productInfo.productId,
                quantity: productInfo.quantity,
                payment_method: paymentMethod,
                coupon_code: couponCode,
                existing_coupons: []
            },
            success: (response) => {
                if (response.success) {
                    this.uiManager.showCouponMessage(response.data.messages.coupon_applied || 'Cupom aplicado com sucesso!', 'success');
                    
                    if (response.data.coupon_codes) {
                        this.appliedCoupons = response.data.coupon_codes;
                    } else if (response.data.new_coupon) {
                        this.appliedCoupons = [couponCode];
                    }
                    
                    jQuery('#vindi-coupon-code').val('');
                    
                    this.updateAppliedCouponsDisplay(response.data.applied_coupons || []);
                    
                    this.mainController.onCouponApplied(response.data);
                } else {
                    this.uiManager.showCouponMessage(response.data || 'Cupom inválido ou não aplicável.', 'error');
                    this.uiManager.hideTotalLoader();
                }
            },
            error: (response) => {
                this.uiManager.showCouponMessage('Erro', 'error');
                this.uiManager.hideTotalLoader();
            },
            complete: () => {
                applyButton.prop('disabled', false);
                loader.hide();
            }
        });
    }

    removeCoupon(couponCode) {
        this.appliedCoupons = [];
        
        this.uiManager.showCouponMessage('Cupom removido.', 'success');

        jQuery('.applied-coupons-container').empty();
        jQuery('.coupon-discount-row').hide();
        jQuery('.coupon-discount-value').html('');
        jQuery('.total-discount-row').hide();
        jQuery('.total-discount-value').html('');
        
        const productInfo = this.mainController.getProductInfo();
        const paymentMethod = jQuery('input[name="payment_method"]:checked').val() || '';
        
        this.uiManager.showTotalLoader();
        
        const subtotalText = jQuery('.subtotal-value').text();
        jQuery('.total-value').html(subtotalText);
        
        jQuery.ajax({
            url: vindiOneClick.ajax_url,
            type: 'POST',
            data: {
                action: 'calculate_one_click_discount',
                nonce: vindiOneClick.nonce,
                product_id: productInfo.productId,
                payment_method: paymentMethod,
                quantity: productInfo.quantity,
                coupon_codes: []
            },
            success: (response) => {
                if (response.success) {
                    this.mainController.onCouponRemoved(response.data);
                    jQuery('.applied-coupons-container').empty();
                }
            },
            error: () => {
                this.uiManager.showCouponMessage('Erro', 'error');
                this.uiManager.hideTotalLoader();
            },
            complete: () => {
                this.uiManager.hideTotalLoader();
            }
        });
    }

    updateAppliedCouponsDisplay(coupons) {
        const container = jQuery('.applied-coupons-container');
        container.empty();
        
        if (coupons.length) {
            const heading = jQuery('<h4>').text('Cupom aplicado:');
            container.append(heading);
            
            const couponList = jQuery('<ul class="applied-coupons-list">');
            
            const coupon = coupons[0];
            const listItem = jQuery('<li class="applied-coupon-item">');
            const text = jQuery('<span class="coupon-code">').text(coupon.code);
            const removeBtn = jQuery('<button type="button" class="remove-coupon">').text('×');
            
            removeBtn.on('click', () => this.removeCoupon(coupon.code));
            
            listItem.append(text);
            if (coupon.description && coupon.description !== coupon.code) {
                listItem.append(' - ', jQuery('<span class="coupon-description">').text(coupon.description));
            }
            listItem.append(removeBtn);
            couponList.append(listItem);
            
            container.append(couponList);
        }
    }

    getAppliedCoupons() {
        return this.appliedCoupons;
    }
}